import {createAction} from '@reduxjs/toolkit';
import {Filters} from 'src/modules/attributes/typedefs';

export const SET_ATTRIBUTES_FILTER = 'SET_ATTRIBUTES_FILTER';
export const CLEAR_ATTRIBUTES_FILTERS = 'CLEAR_ATTRIBUTES_FILTERS';
export const SET_ALL_ATTRIBUTES_FILTERS = 'SET_ALL_ATTRIBUTES_FILTERS';

export const setAllAttributesFilters = createAction<Filters>(SET_ALL_ATTRIBUTES_FILTERS);

export const setAttributesFilter = createAction<{
    filterType: string,
    filterValue: string[],
}>(SET_ATTRIBUTES_FILTER);

export const clearAttributesFilters = createAction(CLEAR_ATTRIBUTES_FILTERS);
